import o from "react";
import { useTheme as z, Flex as s, Image as E, Badge as I } from "@chakra-ui/react";
const S = (t, e) => t[e] ?? t.badge01, B = ({
  badgeClass: t,
  icon: e,
  children: n,
  ...a
}) => {
  var g;
  const {
    element: { spacingSmall: i },
    badge: d,
    badgePaddingVertical: c,
    badgePaddingHorizontal: m,
    badgeBorderRadius: p,
    badgeIconSize: r
  } = z(), { icon: x, text: u, bg: b } = S(d, t), f = e && e.url && /* @__PURE__ */ o.createElement(
    s,
    {
      "data-testid": "startIcon",
      gap: i,
      as: "span",
      sx: {
        svg: { color: x, height: r, width: r }
      }
    },
    /* @__PURE__ */ o.createElement(
      E,
      {
        boxSize: r,
        src: e.url,
        alt: e.altText || "",
        loading: "lazy",
        ...(g = a == null ? void 0 : a.sx) != null && g.maxWidth ? { maxWidth: "initial" } : null
      }
    )
  ), l = typeof n == "string" ? n : "";
  return /* @__PURE__ */ o.createElement(
    I,
    {
      as: "span",
      textTransform: (
        /** RMP-9917: Ad circumvention experiements part B */
        (l == null ? void 0 : l.toLowerCase()) === "sponsored" ? "capitalize" : "none"
      ),
      py: c,
      px: m,
      borderRadius: p,
      bg: b,
      color: u,
      ...d.text,
      ...a
    },
    /* @__PURE__ */ o.createElement(s, { direction: "row", alignItems: "center", gap: i }, f, n)
  );
};
export {
  B as InfoBadge
};
